var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.5,
    width: 25,
    height: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_57_2310",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_57_2310",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABFElEQVRoge2Z0QrCMAxF7wf6Mob44Nf4r9tXOJgNOChd17SVLQnmQMA9COfoWIMCjuNczS3MHGZtnCXMS8B3x4R2+ThCnF8CVgHfHb23kJoAjnuYN4wGcPKqA3LyC4wEHMk/YSCgJA8oD+DkAcUBNfKA0oBaeUBhQIs8oCygVR5QFDBiL0/XD+Z98e40nSnIkS5xNfLEtjvN39dixAG18qqIP8lR2MVxnAwDlDzueqBHYnxIiR44rQdHKi8e0HJ05+TpejhTkKN2eepZzC6hJkCtPMEFqJYnSgHq5YmjABPyRC7AjDyRBpiSJ9IAU/JEGmBKnjAtT5S+gdKo2UJ7A8SXuI3cb/KmAuivzJ4INbeQ4/wTHxgBYpItVgz/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeIcon);
export default __webpack_public_path__ + "static/media/resizeIcon.0210f8ab68447bd05abc8ff5394d173e.svg";
export { ForwardRef as ReactComponent };